/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAutoUpdatedRef } from "../useAutoUpdatedRef"
import { useCallback } from "react"

export function useEvent<T extends (...args: any) => any>(func: T) {
  const ref = useAutoUpdatedRef(func)

  return useCallback((...args: Parameters<T>) => ref.current(...(args as any)), [ref])
}
